import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	description: {
		id: 'platform-board-kit.column.column-configuration.description',
		defaultMessage: 'Configure board',
		description: 'Configure board tooltip',
	},
});
